import { ComponentSize } from '../../../../types';
import { TypographyType } from '../../Typography';

export const MULTI_INPUT_SIZE: Record<string, string> = {
  [ComponentSize.X_SMALL]: 'min-h-5',
  [ComponentSize.SMALL]: 'min-h-8',
  [ComponentSize.MEDIUM]: 'min-h-12',
  [ComponentSize.LARGE]: 'min-h-16',
};

// Mapping size to text variant
export const MULTI_INPUT_SIZE_TO_TYPOGRAPHY_TYPE: Record<ComponentSize, TypographyType> = {
  [ComponentSize.X_SMALL]: TypographyType.X_SMALL,
  [ComponentSize.SMALL]: TypographyType.SMALL,
  [ComponentSize.MEDIUM]: TypographyType.SMALL,
  [ComponentSize.LARGE]: TypographyType.BASE,
};
